/**
 * @desc 新品下单保存草稿
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<string>;
export function request(
  body: defs.basics.PlmSkuNewOrderCreateRequestDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/product/order/saveDraft`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
